export default function Forbidden() {
  return (
    <div style={{ textAlign: "center", marginTop: "4rem" }}>
      <h1>Access Denied</h1>
      <p>You do not have permission to view this page.</p>
    </div>
  );
}